import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IRequestCallback } from '@df/api/request/request.service';
import { CustomformComponentDef } from '@df/catalog-ui/customform/customform.component.def';
import { IAddressBasicData } from '@df/session/api/address-book/address';

declare module '@df/catalog/customform/customform' {
    interface ICustomformField {
        wrappercol: number;
        is_hidden_field: boolean;
        file_number_limit?: number;
        drag_drop_text?: string;
        open_browser_text?: string;
    }
}
@Component({
    selector: 'customform',
    templateUrl: './customform.html',
    styleUrls: ['./customform.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomformComponent extends CustomformComponentDef<{}> {
    protected addressData: IAddressBasicData = {};

    override dataReset(): void {
        super.dataReset();

        // Initialize multi-file upload fields with empty arrays
        this.fields?.forEach(field => {
            if (field.field_type === 'multifile_upload') {
                this.data[field.cid] = [];
            }
        });
    }

    override submit(onSuccess?: IRequestCallback<any>, onError?: IRequestCallback<any>) {
        this.addressDataToCustomFormData();
        this.prepareFileData();
        super.submit(() => {
            this.addressData = {};
        }, onError);
    }

    private prepareFileData(): void {
        // Check if any multi-file upload fields have files
        const hasMultiFiles = this.fields?.some(
            field =>
                field.field_type === 'multifile_upload' &&
                this.data[field.cid] &&
                Array.isArray(this.data[field.cid]) &&
                this.data[field.cid].length > 0
        );

        // Check if any single file upload fields have files
        const hasSingleFiles = this.fields?.some(
            field => field.field_type === 'file_upload' && this.data[field.cid] && this.data[field.cid] instanceof File
        );

        // Set fileUpload flag if any files are present
        if ((hasMultiFiles || hasSingleFiles) && this.requestOptions) {
            this.requestOptions.fileUpload = true;
        }
    }

    private addressDataToCustomFormData(): void {
        const addressFieldCid = this.fields?.find(field => field.field_type === 'address')?.cid;
        if (addressFieldCid) {
            this.data[addressFieldCid] = {
                street: [this.addressData.street_1 || '', this.addressData.street_2 || '', this.addressData.street_3 || ''].join(' '),
                city: this.addressData.city,
                country: this.addressData.country || this.addressData.country_id,
                zipcode: this.addressData.postcode,
                state: this.addressData.region
            };
        }
    }
}
